export default __webpack_public_path__ + "static/logo-dark-375a31fe77da3030ea27076353cc3ec3.png";